import React, {forwardRef} from 'react';

import {CloudinaryImage as CloudinaryImageFromUtils} from '@optimaxdev/utils';
import {PropsType} from '@optimaxdev/utils/dist/types/libs/cloudinary/cloudinaryImage';

/**
 * Cloudinary image wrapper
 */
export const CloudinaryImage = forwardRef<HTMLImageElement, Omit<PropsType, 'device'>>(
    ({...restProps}, ref: React.Ref<HTMLImageElement>) => {
        return (
            <CloudinaryImageFromUtils
                device={__BUILD_TYPE__ as 'desktop' | 'mobile'}
                disabled={process.env.APP_ENV !== 'production'}
                ref={ref}
                {...restProps}
            />
        );
    },
);

CloudinaryImage.displayName = 'CloudinaryImage';
